import { getRowsToDisplay } from "../helpers";

export const onSelectionChangedEvent = ({
  gridRef,
  onSelectionChanged,
  params,
  setSelectedRows,
}) => {

  const rows = gridRef.current.api.getSelectedNodes();
  // Need to include params in the argument
  // NOTE: onSelectionChanged(params)
  if (onSelectionChanged) {
    onSelectionChanged(rows.filter(data => data.selected), params);
  };
  
  if (setSelectedRows) {
    const rowsToDisplay = getRowsToDisplay(params);
    const selectedRows = rowsToDisplay.filter(data => data.selected).length;
    setSelectedRows(selectedRows);
  };

  gridRef.current.api.refreshCells({ force: true }); // this line allows the cell color to go back to it's intial color setting after being deselected
}